import { Fragment, useEffect, useState } from 'react';
import { Col, Grid, Image, Row, Space, Tabs } from 'antd';
import Paragraph from 'antd/lib/typography/Paragraph';
import DOMPurify from 'isomorphic-dompurify';
import CardArticleHBAuthor from 'src/components/Card/ArticleHBAuthor';
import classes from './style.module.less';
const {
  TabPane
} = Tabs;
const AuthorDetails = (props: any) => {
  const {
    xl,
    lg,
    xs
  } = Grid.useBreakpoint();
  const socmeds = props?.event.socmeds;
  const profile = props?.event;
  const sosmed = {
    social_media: [{
      icon: '/images/icon-author/ig.png',
      name: 'instagram'
    }, {
      icon: '/images/icon-author/fb.png',
      name: 'facebook'
    }, {
      icon: '/images/icon-author/tiktok.png',
      name: 'tiktok'
    }, {
      icon: '/images/icon-author/x.png',
      name: 'x'
    }]
  };
  const combined = sosmed?.social_media.map(media => {
    const matched = socmeds?.find((s: any) => s.socmed.toLowerCase() === media.name.toLowerCase());
    return {
      ...media,
      account: matched ? matched.account : null // Menambahkan account jika ada
    };
  });
  const [tabsKey, setTabsKey] = useState('1');
  const handleTab = (key: any) => {
    setTabsKey(key);
  };
  const characterCount = profile?.about.replace(/<[^>]*>/g, '');
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };
  useEffect(() => {
    window.scrollBy({
      top: 5,
      left: 0,
      behavior: 'smooth'
    });
  }, []);
  const firstName = profile?.name?.substring(0, 50);
  const title = profile?.title?.substring(0, 30);
  return <div className={classes.pagehero}>
			<div className={classes['page-body-wrap']}>
				<Row>
					<Col md={6} sm={6} xs={24} lg={6} xl={6} style={{
          borderRight: xs ? 'none' : '#D9D9D9 solid 2px',
          height: xs ? '100px' : '630px',
          marginTop: '10px'
        }}>
						<div className={classes.section}>
							{xs ? <Row>
									<Col xs={7}>
										<Image src={!profile?.media_images ? '/images/author/author.png' : profile.media_images?.original} height={80} width={80} style={{
                  borderRadius: '50%'
                }} preview={false} />
									</Col>
									<Col xs={17}>
										<h1 className={classes.title1}>{firstName}</h1>
										<p className={classes.paragraph1}>{title}</p>

									</Col>
								</Row> : <div>
									<Image src={!profile?.media_images ? '/images/author/author.png' : profile?.media_images?.original} height={80} width={80} style={{
                borderRadius: '50%'
              }} preview={false} />
									<h1 className={classes.title1}>{profile?.name}</h1>
									<p className={classes.paragraph1}>{profile?.title}</p>
								</div>}

						</div>
					</Col>
					<Col md={18} sm={18} xs={24} lg={18} xl={18}>
						<div className={classes.sectionright}>
							<Tabs defaultActiveKey="1" onChange={handleTab}>
								<TabPane tab={<span className={classes.customtab} style={{
                color: tabsKey === '1' ? '#F48A8A' : '#BFAFAF'
              }}>Artikel</span>} key="1">
									<div className={classes.hideScrollbar} style={{
                  height: '520px'
                }}>
										{props.artikel.length === 0 ? <div style={{
                    textAlign: 'center',
                    marginTop: '50px'
                  }}>
													<Image src="/images/author/ctaNull.webp" preview={false} alt='Author-artikel-null' width={358} height={264} />
												</div> : <CardArticleHBAuthor data={props.artikel} type="artikel" />}
									</div>
								</TabPane>
								<TabPane tab={<span className={classes.customtab} style={{
                color: tabsKey === '2' ? '#F48A8A' : '#BFAFAF'
              }}>Info</span>} key="2">
									<div className={classes.hideScrollbar} style={{
                  height: '520px'
                }}>
										{!profile?.about && !profile?.educations && !profile?.experience ? <div style={{
                    textAlign: 'center',
                    marginTop: '50px'
                  }}>
													<Image src="/images/author/ctaNull.webp" preview={false} alt='Author-artikel-null' width={358} height={264} />
												</div> : <div>
													<div>
														<p className={classes.paragraph2}>Tentang</p>
														{profile.about ? <div>
																	<div className={classes.paragraph3} style={{
                          // maxHeight: expanded ? 'none' : '80px',
                          overflow: 'hidden',
                          // transition: 'max-height 0.3s ease',
                          marginBottom: '-1em'
                        }} dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(isExpanded ? profile?.about : profile?.about.substring(0, 301))
                        }} />
																	{characterCount.length < 300 ? '' : <span className={classes.paragraph3} onClick={toggleExpand} style={{
                          color: '#F48A8A',
                          cursor: 'pointer',
                          userSelect: 'none',
                          marginTop: '-5px'
                        }}>
																			{isExpanded === true ? 'Tampilkan Lebih Dikit' : 'Tampilkan Selengkapnya'}
																		</span>}
																</div> : <span className={classes.paragraph3}>-</span>}
													</div>
													<section>
														<p className={classes.paragraph2}>Pendidikan</p>
														{!profile.educations ? <span className={classes.paragraph3}>-</span> : profile.educations.map((item: any, i: number) => {
                        return <div key={i}>
																		<Paragraph className={classes.paragraph3}>
																			{item.program_study} | {item.university}
																		</Paragraph>
																		<Paragraph className={classes.paragraph3} style={{
                            marginTop: '-20px'
                          }}>
																			{item.start_year} -{' '}
																			{item.is_present === true ? ' Sekarang' : item.end_year}
																		</Paragraph>
																	</div>;
                      })}
													</section>
													<section>
														<p className={classes.paragraph2}>Pengalaman</p>
														{!profile.experiences ? <span className={classes.paragraph3}>-</span> : profile.experiences.map((item: any, i: number) => {
                        return <div key={i}>
																		<Paragraph className={classes.paragraph3}>
																			{item.specialization} | {item.working_place}
																		</Paragraph>
																		<Paragraph className={classes.paragraph3} style={{
                            marginTop: '-20px'
                          }}>
																			{item.start_year} -{' '}
																			{item.is_present === true ? ' Sekarang' : item.end_year}
																		</Paragraph>
																	</div>;
                      })}
													</section>
													<Row style={{
                      paddingBottom: '20px'
                    }}>
														<Col sm={21} md={21} lg={21} xl={21} xs={24}>
															<p className={classes.paragraph2} style={{
                          marginBottom: !socmeds ? '0px' : '20px'
                        }}>Sosial Media</p>
															<Space className={classes.icons} size="middle">
																{!socmeds ? <span className={classes.paragraph3}>-</span> : combined?.map((item: any) => {
                            if (item.account !== '') {
                              return <Fragment key={item.name}>
																					<a href={item.account} rel="nofollow noreferrer" id={'detail-artikel-' + item.name} target="_blank">
																						{item.icon && <Image key={item.name} className={classes['socmed-icon']} width={!xl && lg ? 28 : xs ? 24 : 32} height={!xl && lg ? 28 : xs ? 24 : 32} src={item.icon} alt={item.name} preview={false} style={{
                                    cursor: 'pointer'
                                  }} />}
																					</a>
																				</Fragment>;
                            }
                          })}
															</Space>
														</Col>
													</Row>
												</div>}
									</div>
								</TabPane>
							</Tabs>
						</div>
					</Col>
				</Row>
			</div>
		</div>;
};
export default AuthorDetails;